import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const RELOADED_KEY = 'vite-preload-reloaded'

window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem(RELOADED_KEY)) return
  sessionStorage.setItem(RELOADED_KEY, '1')
  window.location.reload()
})

setTimeout(() => sessionStorage.removeItem(RELOADED_KEY), 5000)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
